import React from "react";
import {
  List,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import {
  NoteAdd as NoteAddIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";

import {
  changeExpansion,
  setCurrentEHRNote,
} from "app/store/transmission/slice/transmissionSlice";

import EHRNote from "./EHRNote";
import useEHRNotes from "./useEHRNotes";
import EHRNoteForm from "./EHRNoteForm";

const EHRNotes = ({ data, isFetching }) => {
  const { dispatch, handleEdit, ehrNoteList, canEditEHRNote, ehrNoteExpanded } =
    useEHRNotes(data);

  return (
    <Accordion
      className="view-pdf__panel"
      expanded={ehrNoteExpanded}
      onChange={(e, expanded) => {
        e.preventDefault();
        dispatch(setCurrentEHRNote({}));
        dispatch(changeExpansion({ type: "ehrNotes", value: expanded }));
      }}
      style={{ boxShadow: "none", borderColor: "#E0E0E0" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon data-action="expand-more-ehr-notes-icon" />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <span className="view-pdf__notes-header--icon" style={{ margin: 0 }}>
          <NoteAddIcon />
        </span>
        <div className="view-pdf__notes-header--title" style={{ margin: 0 }}>
          EHR Notes {ehrNoteList?.length > 0 && `(${ehrNoteList?.length})`}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="d-flex flex-column w-100">
          {ehrNoteList?.length > 0 ? (
            <List className="d-flex flex-column" style={{ gap: 8 }}>
              {ehrNoteList?.map((ehrNote, index) => (
                <EHRNote
                  key={`ehrNote-${index}`}
                  ehrNote={ehrNote}
                  handleEdit={handleEdit}
                  canEditEHRNote={canEditEHRNote}
                />
              ))}
            </List>
          ) : (
            <div className="mb-2">No EHR Notes available</div>
          )}
          {canEditEHRNote && (
            <EHRNoteForm data={data} isFetching={isFetching} />
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default EHRNotes;
